import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

const languageOptions = [
  { code: "bs", label: "Bosanski", flag: "🇧🇦" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "sq", label: "Shqip", flag: "🇦🇱" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

export default function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const storedLanguage = localStorage.getItem("selectedLanguage");
  const [selectedLanguage, setSelectedLanguage] = useState(
    storedLanguage || i18n.language
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  useEffect(() => {
    localStorage.setItem("selectedLanguage", selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage, i18n]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (language: string) => {
    setSelectedLanguage(language);
    handleMenuClose();
  };

  const selectedLangObj = languageOptions.find((l) => l.code === selectedLanguage);

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleMenuOpen}
        sx={{ ml: 1 }}
        aria-label={t("navbar.language")}
      >
        <LanguageIcon />
        <span style={{ marginLeft: 6 }}>{selectedLangObj?.flag}</span>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {languageOptions.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={selectedLanguage === lang.code}
            onClick={() => changeLanguage(lang.code)}
          >
            <ListItemIcon>
              <span style={{ fontSize: 22 }}>{lang.flag}</span>
            </ListItemIcon>
            <ListItemText>{lang.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
